import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { Notifications } from '../notifications.types';

import { getUnreadNotificationsCount } from '../notifications.actions';

export const initialState: Notifications = {
  unreadNotificationsCount: 0,
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setUnreadNotificationsCount: (state, action: PayloadAction<number>) => {
      state.unreadNotificationsCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUnreadNotificationsCount.fulfilled, (state, action) => {
        state.unreadNotificationsCount = action.payload.data.unreadCount;
      });
  },
});

export const { reducer: notificationsReducer, actions: notificationsActions } = notificationsSlice;

export const { setUnreadNotificationsCount } = notificationsActions;
